import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SESSION_TIMEOUT = 20 * 60 * 1000; // 20 minutes in milliseconds
const SESSION_KEY = 'sessionStart';
const AUTH_KEY = 'isAuthenticated';

// Function to check if session is valid
export const isSessionValid = (): boolean => {
  const isAuthenticated = localStorage.getItem(AUTH_KEY) === 'true';
  const sessionStart = parseInt(localStorage.getItem(SESSION_KEY) || '0', 10);
  const now = Date.now();

  if (!isAuthenticated || !sessionStart) {
    return false;
  }

  return now - sessionStart < SESSION_TIMEOUT;
};

// Function to initialize or refresh session
export const initSession = () => {
  localStorage.setItem(AUTH_KEY, 'true');
  localStorage.setItem(SESSION_KEY, Date.now().toString());
};

// Function to clear session
export const clearSession = () => {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(SESSION_KEY);
};

export const useSessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if session is valid
    if (!isSessionValid()) {
      clearSession();
      navigate('/admin');
      return;
    }

    // Reset session timer on activity
    const resetSession = () => {
      if (isSessionValid()) {
        initSession();
      }
    };

    // Events that indicate user activity
    const activityEvents = ['mousedown', 'keydown', 'touchstart', 'scroll', 'mousemove'];
    activityEvents.forEach(event => {
      document.addEventListener(event, resetSession);
    });

    // Check session status periodically
    const checkInterval = setInterval(() => {
      if (!isSessionValid()) {
        clearSession();
        navigate('/admin');
      }
    }, 1000);

    // Cleanup
    return () => {
      activityEvents.forEach(event => {
        document.removeEventListener(event, resetSession);
      });
      clearInterval(checkInterval);
    };
  }, [navigate]);
};